// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
var lastScrollTop = 0;

// Selectors
const HEADER_SELECTOR           = '#shopify-section-header';
const ANNOUNCEMENT_BAR_SELECTOR = '.announcement-bar';
const PRODUCT_SECTION = '#shopify-section-product';

// Classes
const STICKY_CLASS = 'is-sticky';
const ANNOUNCEMENT_BAR_HIDDEN_CLASS = 'announcement-bar--hidden';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('scroll', function() {
    const productSection = document.querySelector(PRODUCT_SECTION);
    
    if (productSection === null) {
        const headerSection   = document.querySelector(HEADER_SELECTOR);
        const announcementBar = document.querySelector(ANNOUNCEMENT_BAR_SELECTOR);
        const noScrollBody    = document.querySelector('body.noscroll');
        var   st              = document.documentElement.scrollTop;

        if (st > lastScrollTop || st == 0) { // If scrolling down
            headerSection.classList.remove(STICKY_CLASS);
    
            // Re-position the regular header depending on if there is the announcement bar or not
            if (noScrollBody) { // if on mobile and when the menu is open.
                headerSection.style.top = 0;
            } else {
                headerSection.style.top = '-100px';
            }
    
            if (announcementBar !== null) {
                announcementBar.classList.remove(STICKY_CLASS);
            }
        } else if (st < lastScrollTop) { // If scrolling up
            headerSection.classList.add(STICKY_CLASS);
            
            if (announcementBar !== null) {
                announcementBar.classList.add(STICKY_CLASS);
            }
    
            // Re-position the sticky header depending on if there is the announcement bar or not. 
            if ((announcementBar !== null && announcementBar.classList.contains(ANNOUNCEMENT_BAR_HIDDEN_CLASS)) || announcementBar === null) {
                headerSection.style.top = 0;
            } else {
                headerSection.style.top = '0';
            }
        } 
        lastScrollTop = st <= 0 ? 0 : st;
    }
});
